/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SilentTokenRenewRouteImport } from './routes/silent-token-renew'
import { Route as LoginCompleteRouteImport } from './routes/login-complete'
import { Route as DevicesRouteImport } from './routes/devices'
import { Route as servicesServicesRouteImport } from './routes/(services)/services'
import { Route as securitySecurityRouteImport } from './routes/(security)/security'
import { Route as homeHomeRouteImport } from './routes/(home)/home'
import { Route as tvTvIndexRouteImport } from './routes/(tv)/tv/index'
import { Route as tvTvIdRouteImport } from './routes/(tv)/tv/$id'
import { Route as servicesServicesSheetRouteImport } from './routes/(services)/services/_sheet'
import { Route as securitySecuritySheetRouteImport } from './routes/(security)/security/_sheet'
import { Route as securitySecurityMfaSetupRouteImport } from './routes/(security)/security/_mfa-setup'
import { Route as homeHomechangePasswordSheetRouteImport } from './routes/(home)/home/(change-password)/_sheet'
import { Route as homeHomechangeContactsSheetRouteImport } from './routes/(home)/home/(change-contacts)/_sheet'
import { Route as servicesServicesSheetUsersIndexRouteImport } from './routes/(services)/services/_sheet.users/index'
import { Route as servicesServicesSheetSwitchServicesIndexRouteImport } from './routes/(services)/services/_sheet.switch-services/index'
import { Route as servicesServicesSheetDefaultHouseholdIndexRouteImport } from './routes/(services)/services/_sheet.default-household/index'
import { Route as servicesServicesSheetAppsIndexRouteImport } from './routes/(services)/services/_sheet.apps/index'
import { Route as securitySecuritySheetTwoFactorCodeIndexRouteImport } from './routes/(security)/security/_sheet.two-factor-code/index'
import { Route as securitySecuritySheetActiveSessionsIndexRouteImport } from './routes/(security)/security/_sheet.active-sessions/index'
import { Route as securitySecuritySheetAccountActivityIndexRouteImport } from './routes/(security)/security/_sheet.account-activity/index'
import { Route as tvTvIdtvProfilesSheetRouteImport } from './routes/(tv)/tv/$id/(tv-profiles)/_sheet'
import { Route as tvTvIdpinsSheetRouteImport } from './routes/(tv)/tv/$id/(pins)/_sheet'
import { Route as tvTvIddeviceManagementSheetRouteImport } from './routes/(tv)/tv/$id/(device-management)/_sheet'
import { Route as servicesServicesSheetUsersInviteSuccessIndexRouteImport } from './routes/(services)/services/_sheet.users/invite-success/index'
import { Route as servicesServicesSheetUsersAddIndexRouteImport } from './routes/(services)/services/_sheet.users/add/index'
import { Route as servicesServicesSheetUsersUserIdIndexRouteImport } from './routes/(services)/services/_sheet.users/$userId/index'
import { Route as servicesServicesSheetSwitchServicesSuccessIndexRouteImport } from './routes/(services)/services/_sheet.switch-services/success/index'
import { Route as servicesServicesSheetSwitchServicesHolderInputIndexRouteImport } from './routes/(services)/services/_sheet.switch-services/holder-input/index'
import { Route as servicesServicesSheetSwitchServicesContactSelectionIndexRouteImport } from './routes/(services)/services/_sheet.switch-services/contact-selection/index'
import { Route as servicesServicesSheetSwitchServicesCodeInputIndexRouteImport } from './routes/(services)/services/_sheet.switch-services/code-input/index'
import { Route as securitySecuritySheetAccountActivityFiltersIndexRouteImport } from './routes/(security)/security/_sheet.account-activity/filters/index'
import { Route as securitySecurityMfaSetupAuthenticatorAppValidateIndexRouteImport } from './routes/(security)/security/_mfa-setup.authenticator-app/validate/index'
import { Route as securitySecurityMfaSetupAuthenticatorAppRegisterIndexRouteImport } from './routes/(security)/security/_mfa-setup.authenticator-app/register/index'
import { Route as securitySecurityMfaSetupAuthenticatorAppDownloadAppIndexRouteImport } from './routes/(security)/security/_mfa-setup.authenticator-app/download-app/index'
import { Route as securitySecurityMfaSetupAuthenticatorAppCompleteIndexRouteImport } from './routes/(security)/security/_mfa-setup.authenticator-app/complete/index'
import { Route as tvTvIddeviceManagementSheetDeviceManagementIndexRouteImport } from './routes/(tv)/tv/$id/(device-management)/_sheet.device-management/index'
import { Route as homeHomechangePasswordSheetChangePasswordNewPasswordIndexRouteImport } from './routes/(home)/home/(change-password)/_sheet.change-password/new-password/index'
import { Route as homeHomechangePasswordSheetChangePasswordContactSelectionIndexRouteImport } from './routes/(home)/home/(change-password)/_sheet.change-password/contact-selection/index'
import { Route as homeHomechangePasswordSheetChangePasswordCodeInputIndexRouteImport } from './routes/(home)/home/(change-password)/_sheet.change-password/code-input/index'
import { Route as homeHomechangePasswordSheetChangePasswordlandingPageIndexRouteImport } from './routes/(home)/home/(change-password)/_sheet.change-password/(landing-page)/index'
import { Route as homeHomechangeContactsSheetChangeContactsUsernameIndexRouteImport } from './routes/(home)/home/(change-contacts)/_sheet.change-contacts/username/index'
import { Route as homeHomechangeContactsSheetChangeContactsNewContactIndexRouteImport } from './routes/(home)/home/(change-contacts)/_sheet.change-contacts/new-contact/index'
import { Route as homeHomechangeContactsSheetChangeContactsCodeInputIndexRouteImport } from './routes/(home)/home/(change-contacts)/_sheet.change-contacts/code-input/index'
import { Route as homeHomechangeContactsSheetChangeContactslandingPageIndexRouteImport } from './routes/(home)/home/(change-contacts)/_sheet.change-contacts/(landing-page)/index'
import { Route as tvTvIdtvProfilesSheetProfilesSelectAvatarIndexRouteImport } from './routes/(tv)/tv/$id/(tv-profiles)/_sheet.profiles/select-avatar/index'
import { Route as tvTvIdtvProfilesSheetProfilesCreateIndexRouteImport } from './routes/(tv)/tv/$id/(tv-profiles)/_sheet.profiles/create/index'
import { Route as tvTvIdtvProfilesSheetProfileslistIndexRouteImport } from './routes/(tv)/tv/$id/(tv-profiles)/_sheet.profiles/(list)/index'
import { Route as tvTvIdpinsSheetPinspinsIndexRouteImport } from './routes/(tv)/tv/$id/(pins)/_sheet.pins/(pins)/index'
import { Route as tvTvIdpinsSheetPinsPinIndexRouteImport } from './routes/(tv)/tv/$id/(pins)/_sheet.pins/$pin/index'
import { Route as tvTvIdtvProfilesSheetProfilesProfileIdUpdateIndexRouteImport } from './routes/(tv)/tv/$id/(tv-profiles)/_sheet.profiles/$profileId/update/index'
import { Route as tvTvIdpinsSheetPinsPinContactSelectionIndexRouteImport } from './routes/(tv)/tv/$id/(pins)/_sheet.pins/$pin/contact-selection/index'
import { Route as tvTvIdpinsSheetPinsPinCodeInputIndexRouteImport } from './routes/(tv)/tv/$id/(pins)/_sheet.pins/$pin/code-input/index'
import { Route as tvTvIdtvProfilesSheetProfilesProfileIdUpdatePinValidationIndexRouteImport } from './routes/(tv)/tv/$id/(tv-profiles)/_sheet.profiles/$profileId/update/pin-validation/index'
import { Route as tvTvIdtvProfilesSheetProfilesProfileIdUpdateContactSelectionIndexRouteImport } from './routes/(tv)/tv/$id/(tv-profiles)/_sheet.profiles/$profileId/update/contact-selection/index'
import { Route as tvTvIdtvProfilesSheetProfilesProfileIdUpdateCodeInputIndexRouteImport } from './routes/(tv)/tv/$id/(tv-profiles)/_sheet.profiles/$profileId/update/code-input/index'

const SilentTokenRenewRoute = SilentTokenRenewRouteImport.update({
  id: '/silent-token-renew',
  path: '/silent-token-renew',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginCompleteRoute = LoginCompleteRouteImport.update({
  id: '/login-complete',
  path: '/login-complete',
  getParentRoute: () => rootRouteImport,
} as any)
const DevicesRoute = DevicesRouteImport.update({
  id: '/devices',
  path: '/devices',
  getParentRoute: () => rootRouteImport,
} as any)
const servicesServicesRoute = servicesServicesRouteImport.update({
  id: '/(services)/services',
  path: '/services',
  getParentRoute: () => rootRouteImport,
} as any)
const securitySecurityRoute = securitySecurityRouteImport.update({
  id: '/(security)/security',
  path: '/security',
  getParentRoute: () => rootRouteImport,
} as any)
const homeHomeRoute = homeHomeRouteImport.update({
  id: '/(home)/home',
  path: '/home',
  getParentRoute: () => rootRouteImport,
} as any)
const tvTvIndexRoute = tvTvIndexRouteImport.update({
  id: '/(tv)/tv/',
  path: '/tv/',
  getParentRoute: () => rootRouteImport,
} as any)
const tvTvIdRoute = tvTvIdRouteImport.update({
  id: '/(tv)/tv/$id',
  path: '/tv/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const servicesServicesSheetRoute = servicesServicesSheetRouteImport.update({
  id: '/_sheet',
  getParentRoute: () => servicesServicesRoute,
} as any)
const securitySecuritySheetRoute = securitySecuritySheetRouteImport.update({
  id: '/_sheet',
  getParentRoute: () => securitySecurityRoute,
} as any)
const securitySecurityMfaSetupRoute =
  securitySecurityMfaSetupRouteImport.update({
    id: '/_mfa-setup',
    getParentRoute: () => securitySecurityRoute,
  } as any)
const homeHomechangePasswordSheetRoute =
  homeHomechangePasswordSheetRouteImport.update({
    id: '/(change-password)/_sheet',
    getParentRoute: () => homeHomeRoute,
  } as any)
const homeHomechangeContactsSheetRoute =
  homeHomechangeContactsSheetRouteImport.update({
    id: '/(change-contacts)/_sheet',
    getParentRoute: () => homeHomeRoute,
  } as any)
const servicesServicesSheetUsersIndexRoute =
  servicesServicesSheetUsersIndexRouteImport.update({
    id: '/users/',
    path: '/users/',
    getParentRoute: () => servicesServicesSheetRoute,
  } as any)
const servicesServicesSheetSwitchServicesIndexRoute =
  servicesServicesSheetSwitchServicesIndexRouteImport.update({
    id: '/switch-services/',
    path: '/switch-services/',
    getParentRoute: () => servicesServicesSheetRoute,
  } as any)
const servicesServicesSheetDefaultHouseholdIndexRoute =
  servicesServicesSheetDefaultHouseholdIndexRouteImport.update({
    id: '/default-household/',
    path: '/default-household/',
    getParentRoute: () => servicesServicesSheetRoute,
  } as any)
const servicesServicesSheetAppsIndexRoute =
  servicesServicesSheetAppsIndexRouteImport.update({
    id: '/apps/',
    path: '/apps/',
    getParentRoute: () => servicesServicesSheetRoute,
  } as any)
const securitySecuritySheetTwoFactorCodeIndexRoute =
  securitySecuritySheetTwoFactorCodeIndexRouteImport.update({
    id: '/two-factor-code/',
    path: '/two-factor-code/',
    getParentRoute: () => securitySecuritySheetRoute,
  } as any)
const securitySecuritySheetActiveSessionsIndexRoute =
  securitySecuritySheetActiveSessionsIndexRouteImport.update({
    id: '/active-sessions/',
    path: '/active-sessions/',
    getParentRoute: () => securitySecuritySheetRoute,
  } as any)
const securitySecuritySheetAccountActivityIndexRoute =
  securitySecuritySheetAccountActivityIndexRouteImport.update({
    id: '/account-activity/',
    path: '/account-activity/',
    getParentRoute: () => securitySecuritySheetRoute,
  } as any)
const tvTvIdtvProfilesSheetRoute = tvTvIdtvProfilesSheetRouteImport.update({
  id: '/(tv-profiles)/_sheet',
  getParentRoute: () => tvTvIdRoute,
} as any)
const tvTvIdpinsSheetRoute = tvTvIdpinsSheetRouteImport.update({
  id: '/(pins)/_sheet',
  getParentRoute: () => tvTvIdRoute,
} as any)
const tvTvIddeviceManagementSheetRoute =
  tvTvIddeviceManagementSheetRouteImport.update({
    id: '/(device-management)/_sheet',
    getParentRoute: () => tvTvIdRoute,
  } as any)
const servicesServicesSheetUsersInviteSuccessIndexRoute =
  servicesServicesSheetUsersInviteSuccessIndexRouteImport.update({
    id: '/users/invite-success/',
    path: '/users/invite-success/',
    getParentRoute: () => servicesServicesSheetRoute,
  } as any)
const servicesServicesSheetUsersAddIndexRoute =
  servicesServicesSheetUsersAddIndexRouteImport.update({
    id: '/users/add/',
    path: '/users/add/',
    getParentRoute: () => servicesServicesSheetRoute,
  } as any)
const servicesServicesSheetUsersUserIdIndexRoute =
  servicesServicesSheetUsersUserIdIndexRouteImport.update({
    id: '/users/$userId/',
    path: '/users/$userId/',
    getParentRoute: () => servicesServicesSheetRoute,
  } as any)
const servicesServicesSheetSwitchServicesSuccessIndexRoute =
  servicesServicesSheetSwitchServicesSuccessIndexRouteImport.update({
    id: '/switch-services/success/',
    path: '/switch-services/success/',
    getParentRoute: () => servicesServicesSheetRoute,
  } as any)
const servicesServicesSheetSwitchServicesHolderInputIndexRoute =
  servicesServicesSheetSwitchServicesHolderInputIndexRouteImport.update({
    id: '/switch-services/holder-input/',
    path: '/switch-services/holder-input/',
    getParentRoute: () => servicesServicesSheetRoute,
  } as any)
const servicesServicesSheetSwitchServicesContactSelectionIndexRoute =
  servicesServicesSheetSwitchServicesContactSelectionIndexRouteImport.update({
    id: '/switch-services/contact-selection/',
    path: '/switch-services/contact-selection/',
    getParentRoute: () => servicesServicesSheetRoute,
  } as any)
const servicesServicesSheetSwitchServicesCodeInputIndexRoute =
  servicesServicesSheetSwitchServicesCodeInputIndexRouteImport.update({
    id: '/switch-services/code-input/',
    path: '/switch-services/code-input/',
    getParentRoute: () => servicesServicesSheetRoute,
  } as any)
const securitySecuritySheetAccountActivityFiltersIndexRoute =
  securitySecuritySheetAccountActivityFiltersIndexRouteImport.update({
    id: '/account-activity/filters/',
    path: '/account-activity/filters/',
    getParentRoute: () => securitySecuritySheetRoute,
  } as any)
const securitySecurityMfaSetupAuthenticatorAppValidateIndexRoute =
  securitySecurityMfaSetupAuthenticatorAppValidateIndexRouteImport.update({
    id: '/authenticator-app/validate/',
    path: '/authenticator-app/validate/',
    getParentRoute: () => securitySecurityMfaSetupRoute,
  } as any)
const securitySecurityMfaSetupAuthenticatorAppRegisterIndexRoute =
  securitySecurityMfaSetupAuthenticatorAppRegisterIndexRouteImport.update({
    id: '/authenticator-app/register/',
    path: '/authenticator-app/register/',
    getParentRoute: () => securitySecurityMfaSetupRoute,
  } as any)
const securitySecurityMfaSetupAuthenticatorAppDownloadAppIndexRoute =
  securitySecurityMfaSetupAuthenticatorAppDownloadAppIndexRouteImport.update({
    id: '/authenticator-app/download-app/',
    path: '/authenticator-app/download-app/',
    getParentRoute: () => securitySecurityMfaSetupRoute,
  } as any)
const securitySecurityMfaSetupAuthenticatorAppCompleteIndexRoute =
  securitySecurityMfaSetupAuthenticatorAppCompleteIndexRouteImport.update({
    id: '/authenticator-app/complete/',
    path: '/authenticator-app/complete/',
    getParentRoute: () => securitySecurityMfaSetupRoute,
  } as any)
const tvTvIddeviceManagementSheetDeviceManagementIndexRoute =
  tvTvIddeviceManagementSheetDeviceManagementIndexRouteImport.update({
    id: '/device-management/',
    path: '/device-management/',
    getParentRoute: () => tvTvIddeviceManagementSheetRoute,
  } as any)
const homeHomechangePasswordSheetChangePasswordNewPasswordIndexRoute =
  homeHomechangePasswordSheetChangePasswordNewPasswordIndexRouteImport.update({
    id: '/change-password/new-password/',
    path: '/change-password/new-password/',
    getParentRoute: () => homeHomechangePasswordSheetRoute,
  } as any)
const homeHomechangePasswordSheetChangePasswordContactSelectionIndexRoute =
  homeHomechangePasswordSheetChangePasswordContactSelectionIndexRouteImport.update(
    {
      id: '/change-password/contact-selection/',
      path: '/change-password/contact-selection/',
      getParentRoute: () => homeHomechangePasswordSheetRoute,
    } as any,
  )
const homeHomechangePasswordSheetChangePasswordCodeInputIndexRoute =
  homeHomechangePasswordSheetChangePasswordCodeInputIndexRouteImport.update({
    id: '/change-password/code-input/',
    path: '/change-password/code-input/',
    getParentRoute: () => homeHomechangePasswordSheetRoute,
  } as any)
const homeHomechangePasswordSheetChangePasswordlandingPageIndexRoute =
  homeHomechangePasswordSheetChangePasswordlandingPageIndexRouteImport.update({
    id: '/change-password/(landing-page)/',
    path: '/change-password/',
    getParentRoute: () => homeHomechangePasswordSheetRoute,
  } as any)
const homeHomechangeContactsSheetChangeContactsUsernameIndexRoute =
  homeHomechangeContactsSheetChangeContactsUsernameIndexRouteImport.update({
    id: '/change-contacts/username/',
    path: '/change-contacts/username/',
    getParentRoute: () => homeHomechangeContactsSheetRoute,
  } as any)
const homeHomechangeContactsSheetChangeContactsNewContactIndexRoute =
  homeHomechangeContactsSheetChangeContactsNewContactIndexRouteImport.update({
    id: '/change-contacts/new-contact/',
    path: '/change-contacts/new-contact/',
    getParentRoute: () => homeHomechangeContactsSheetRoute,
  } as any)
const homeHomechangeContactsSheetChangeContactsCodeInputIndexRoute =
  homeHomechangeContactsSheetChangeContactsCodeInputIndexRouteImport.update({
    id: '/change-contacts/code-input/',
    path: '/change-contacts/code-input/',
    getParentRoute: () => homeHomechangeContactsSheetRoute,
  } as any)
const homeHomechangeContactsSheetChangeContactslandingPageIndexRoute =
  homeHomechangeContactsSheetChangeContactslandingPageIndexRouteImport.update({
    id: '/change-contacts/(landing-page)/',
    path: '/change-contacts/',
    getParentRoute: () => homeHomechangeContactsSheetRoute,
  } as any)
const tvTvIdtvProfilesSheetProfilesSelectAvatarIndexRoute =
  tvTvIdtvProfilesSheetProfilesSelectAvatarIndexRouteImport.update({
    id: '/profiles/select-avatar/',
    path: '/profiles/select-avatar/',
    getParentRoute: () => tvTvIdtvProfilesSheetRoute,
  } as any)
const tvTvIdtvProfilesSheetProfilesCreateIndexRoute =
  tvTvIdtvProfilesSheetProfilesCreateIndexRouteImport.update({
    id: '/profiles/create/',
    path: '/profiles/create/',
    getParentRoute: () => tvTvIdtvProfilesSheetRoute,
  } as any)
const tvTvIdtvProfilesSheetProfileslistIndexRoute =
  tvTvIdtvProfilesSheetProfileslistIndexRouteImport.update({
    id: '/profiles/(list)/',
    path: '/profiles/',
    getParentRoute: () => tvTvIdtvProfilesSheetRoute,
  } as any)
const tvTvIdpinsSheetPinspinsIndexRoute =
  tvTvIdpinsSheetPinspinsIndexRouteImport.update({
    id: '/pins/(pins)/',
    path: '/pins/',
    getParentRoute: () => tvTvIdpinsSheetRoute,
  } as any)
const tvTvIdpinsSheetPinsPinIndexRoute =
  tvTvIdpinsSheetPinsPinIndexRouteImport.update({
    id: '/pins/$pin/',
    path: '/pins/$pin/',
    getParentRoute: () => tvTvIdpinsSheetRoute,
  } as any)
const tvTvIdtvProfilesSheetProfilesProfileIdUpdateIndexRoute =
  tvTvIdtvProfilesSheetProfilesProfileIdUpdateIndexRouteImport.update({
    id: '/profiles/$profileId/update/',
    path: '/profiles/$profileId/update/',
    getParentRoute: () => tvTvIdtvProfilesSheetRoute,
  } as any)
const tvTvIdpinsSheetPinsPinContactSelectionIndexRoute =
  tvTvIdpinsSheetPinsPinContactSelectionIndexRouteImport.update({
    id: '/pins/$pin/contact-selection/',
    path: '/pins/$pin/contact-selection/',
    getParentRoute: () => tvTvIdpinsSheetRoute,
  } as any)
const tvTvIdpinsSheetPinsPinCodeInputIndexRoute =
  tvTvIdpinsSheetPinsPinCodeInputIndexRouteImport.update({
    id: '/pins/$pin/code-input/',
    path: '/pins/$pin/code-input/',
    getParentRoute: () => tvTvIdpinsSheetRoute,
  } as any)
const tvTvIdtvProfilesSheetProfilesProfileIdUpdatePinValidationIndexRoute =
  tvTvIdtvProfilesSheetProfilesProfileIdUpdatePinValidationIndexRouteImport.update(
    {
      id: '/profiles/$profileId/update/pin-validation/',
      path: '/profiles/$profileId/update/pin-validation/',
      getParentRoute: () => tvTvIdtvProfilesSheetRoute,
    } as any,
  )
const tvTvIdtvProfilesSheetProfilesProfileIdUpdateContactSelectionIndexRoute =
  tvTvIdtvProfilesSheetProfilesProfileIdUpdateContactSelectionIndexRouteImport.update(
    {
      id: '/profiles/$profileId/update/contact-selection/',
      path: '/profiles/$profileId/update/contact-selection/',
      getParentRoute: () => tvTvIdtvProfilesSheetRoute,
    } as any,
  )
const tvTvIdtvProfilesSheetProfilesProfileIdUpdateCodeInputIndexRoute =
  tvTvIdtvProfilesSheetProfilesProfileIdUpdateCodeInputIndexRouteImport.update({
    id: '/profiles/$profileId/update/code-input/',
    path: '/profiles/$profileId/update/code-input/',
    getParentRoute: () => tvTvIdtvProfilesSheetRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/devices': typeof DevicesRoute
  '/login-complete': typeof LoginCompleteRoute
  '/silent-token-renew': typeof SilentTokenRenewRoute
  '/home': typeof homeHomechangePasswordSheetRouteWithChildren
  '/security': typeof securitySecuritySheetRouteWithChildren
  '/services': typeof servicesServicesSheetRouteWithChildren
  '/tv/$id': typeof tvTvIdtvProfilesSheetRouteWithChildren
  '/tv/': typeof tvTvIndexRoute
  '/security/account-activity/': typeof securitySecuritySheetAccountActivityIndexRoute
  '/security/active-sessions/': typeof securitySecuritySheetActiveSessionsIndexRoute
  '/security/two-factor-code/': typeof securitySecuritySheetTwoFactorCodeIndexRoute
  '/services/apps/': typeof servicesServicesSheetAppsIndexRoute
  '/services/default-household/': typeof servicesServicesSheetDefaultHouseholdIndexRoute
  '/services/switch-services/': typeof servicesServicesSheetSwitchServicesIndexRoute
  '/services/users/': typeof servicesServicesSheetUsersIndexRoute
  '/security/authenticator-app/complete/': typeof securitySecurityMfaSetupAuthenticatorAppCompleteIndexRoute
  '/security/authenticator-app/download-app/': typeof securitySecurityMfaSetupAuthenticatorAppDownloadAppIndexRoute
  '/security/authenticator-app/register/': typeof securitySecurityMfaSetupAuthenticatorAppRegisterIndexRoute
  '/security/authenticator-app/validate/': typeof securitySecurityMfaSetupAuthenticatorAppValidateIndexRoute
  '/security/account-activity/filters/': typeof securitySecuritySheetAccountActivityFiltersIndexRoute
  '/services/switch-services/code-input/': typeof servicesServicesSheetSwitchServicesCodeInputIndexRoute
  '/services/switch-services/contact-selection/': typeof servicesServicesSheetSwitchServicesContactSelectionIndexRoute
  '/services/switch-services/holder-input/': typeof servicesServicesSheetSwitchServicesHolderInputIndexRoute
  '/services/switch-services/success/': typeof servicesServicesSheetSwitchServicesSuccessIndexRoute
  '/services/users/$userId/': typeof servicesServicesSheetUsersUserIdIndexRoute
  '/services/users/add/': typeof servicesServicesSheetUsersAddIndexRoute
  '/services/users/invite-success/': typeof servicesServicesSheetUsersInviteSuccessIndexRoute
  '/home/change-contacts/': typeof homeHomechangeContactsSheetChangeContactslandingPageIndexRoute
  '/home/change-contacts/code-input/': typeof homeHomechangeContactsSheetChangeContactsCodeInputIndexRoute
  '/home/change-contacts/new-contact/': typeof homeHomechangeContactsSheetChangeContactsNewContactIndexRoute
  '/home/change-contacts/username/': typeof homeHomechangeContactsSheetChangeContactsUsernameIndexRoute
  '/home/change-password/': typeof homeHomechangePasswordSheetChangePasswordlandingPageIndexRoute
  '/home/change-password/code-input/': typeof homeHomechangePasswordSheetChangePasswordCodeInputIndexRoute
  '/home/change-password/contact-selection/': typeof homeHomechangePasswordSheetChangePasswordContactSelectionIndexRoute
  '/home/change-password/new-password/': typeof homeHomechangePasswordSheetChangePasswordNewPasswordIndexRoute
  '/tv/$id/device-management/': typeof tvTvIddeviceManagementSheetDeviceManagementIndexRoute
  '/tv/$id/pins/$pin/': typeof tvTvIdpinsSheetPinsPinIndexRoute
  '/tv/$id/pins/': typeof tvTvIdpinsSheetPinspinsIndexRoute
  '/tv/$id/profiles/': typeof tvTvIdtvProfilesSheetProfileslistIndexRoute
  '/tv/$id/profiles/create/': typeof tvTvIdtvProfilesSheetProfilesCreateIndexRoute
  '/tv/$id/profiles/select-avatar/': typeof tvTvIdtvProfilesSheetProfilesSelectAvatarIndexRoute
  '/tv/$id/pins/$pin/code-input/': typeof tvTvIdpinsSheetPinsPinCodeInputIndexRoute
  '/tv/$id/pins/$pin/contact-selection/': typeof tvTvIdpinsSheetPinsPinContactSelectionIndexRoute
  '/tv/$id/profiles/$profileId/update/': typeof tvTvIdtvProfilesSheetProfilesProfileIdUpdateIndexRoute
  '/tv/$id/profiles/$profileId/update/code-input/': typeof tvTvIdtvProfilesSheetProfilesProfileIdUpdateCodeInputIndexRoute
  '/tv/$id/profiles/$profileId/update/contact-selection/': typeof tvTvIdtvProfilesSheetProfilesProfileIdUpdateContactSelectionIndexRoute
  '/tv/$id/profiles/$profileId/update/pin-validation/': typeof tvTvIdtvProfilesSheetProfilesProfileIdUpdatePinValidationIndexRoute
}
export interface FileRoutesByTo {
  '/devices': typeof DevicesRoute
  '/login-complete': typeof LoginCompleteRoute
  '/silent-token-renew': typeof SilentTokenRenewRoute
  '/home': typeof homeHomechangePasswordSheetRouteWithChildren
  '/security': typeof securitySecuritySheetRouteWithChildren
  '/services': typeof servicesServicesSheetRouteWithChildren
  '/tv/$id': typeof tvTvIdtvProfilesSheetRouteWithChildren
  '/tv': typeof tvTvIndexRoute
  '/security/account-activity': typeof securitySecuritySheetAccountActivityIndexRoute
  '/security/active-sessions': typeof securitySecuritySheetActiveSessionsIndexRoute
  '/security/two-factor-code': typeof securitySecuritySheetTwoFactorCodeIndexRoute
  '/services/apps': typeof servicesServicesSheetAppsIndexRoute
  '/services/default-household': typeof servicesServicesSheetDefaultHouseholdIndexRoute
  '/services/switch-services': typeof servicesServicesSheetSwitchServicesIndexRoute
  '/services/users': typeof servicesServicesSheetUsersIndexRoute
  '/security/authenticator-app/complete': typeof securitySecurityMfaSetupAuthenticatorAppCompleteIndexRoute
  '/security/authenticator-app/download-app': typeof securitySecurityMfaSetupAuthenticatorAppDownloadAppIndexRoute
  '/security/authenticator-app/register': typeof securitySecurityMfaSetupAuthenticatorAppRegisterIndexRoute
  '/security/authenticator-app/validate': typeof securitySecurityMfaSetupAuthenticatorAppValidateIndexRoute
  '/security/account-activity/filters': typeof securitySecuritySheetAccountActivityFiltersIndexRoute
  '/services/switch-services/code-input': typeof servicesServicesSheetSwitchServicesCodeInputIndexRoute
  '/services/switch-services/contact-selection': typeof servicesServicesSheetSwitchServicesContactSelectionIndexRoute
  '/services/switch-services/holder-input': typeof servicesServicesSheetSwitchServicesHolderInputIndexRoute
  '/services/switch-services/success': typeof servicesServicesSheetSwitchServicesSuccessIndexRoute
  '/services/users/$userId': typeof servicesServicesSheetUsersUserIdIndexRoute
  '/services/users/add': typeof servicesServicesSheetUsersAddIndexRoute
  '/services/users/invite-success': typeof servicesServicesSheetUsersInviteSuccessIndexRoute
  '/home/change-contacts': typeof homeHomechangeContactsSheetChangeContactslandingPageIndexRoute
  '/home/change-contacts/code-input': typeof homeHomechangeContactsSheetChangeContactsCodeInputIndexRoute
  '/home/change-contacts/new-contact': typeof homeHomechangeContactsSheetChangeContactsNewContactIndexRoute
  '/home/change-contacts/username': typeof homeHomechangeContactsSheetChangeContactsUsernameIndexRoute
  '/home/change-password': typeof homeHomechangePasswordSheetChangePasswordlandingPageIndexRoute
  '/home/change-password/code-input': typeof homeHomechangePasswordSheetChangePasswordCodeInputIndexRoute
  '/home/change-password/contact-selection': typeof homeHomechangePasswordSheetChangePasswordContactSelectionIndexRoute
  '/home/change-password/new-password': typeof homeHomechangePasswordSheetChangePasswordNewPasswordIndexRoute
  '/tv/$id/device-management': typeof tvTvIddeviceManagementSheetDeviceManagementIndexRoute
  '/tv/$id/pins/$pin': typeof tvTvIdpinsSheetPinsPinIndexRoute
  '/tv/$id/pins': typeof tvTvIdpinsSheetPinspinsIndexRoute
  '/tv/$id/profiles': typeof tvTvIdtvProfilesSheetProfileslistIndexRoute
  '/tv/$id/profiles/create': typeof tvTvIdtvProfilesSheetProfilesCreateIndexRoute
  '/tv/$id/profiles/select-avatar': typeof tvTvIdtvProfilesSheetProfilesSelectAvatarIndexRoute
  '/tv/$id/pins/$pin/code-input': typeof tvTvIdpinsSheetPinsPinCodeInputIndexRoute
  '/tv/$id/pins/$pin/contact-selection': typeof tvTvIdpinsSheetPinsPinContactSelectionIndexRoute
  '/tv/$id/profiles/$profileId/update': typeof tvTvIdtvProfilesSheetProfilesProfileIdUpdateIndexRoute
  '/tv/$id/profiles/$profileId/update/code-input': typeof tvTvIdtvProfilesSheetProfilesProfileIdUpdateCodeInputIndexRoute
  '/tv/$id/profiles/$profileId/update/contact-selection': typeof tvTvIdtvProfilesSheetProfilesProfileIdUpdateContactSelectionIndexRoute
  '/tv/$id/profiles/$profileId/update/pin-validation': typeof tvTvIdtvProfilesSheetProfilesProfileIdUpdatePinValidationIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/devices': typeof DevicesRoute
  '/login-complete': typeof LoginCompleteRoute
  '/silent-token-renew': typeof SilentTokenRenewRoute
  '/(home)/home': typeof homeHomeRouteWithChildren
  '/(security)/security': typeof securitySecurityRouteWithChildren
  '/(services)/services': typeof servicesServicesRouteWithChildren
  '/(security)/security/_mfa-setup': typeof securitySecurityMfaSetupRouteWithChildren
  '/(security)/security/_sheet': typeof securitySecuritySheetRouteWithChildren
  '/(services)/services/_sheet': typeof servicesServicesSheetRouteWithChildren
  '/(tv)/tv/$id': typeof tvTvIdRouteWithChildren
  '/(tv)/tv/': typeof tvTvIndexRoute
  '/(home)/home/(change-contacts)/_sheet': typeof homeHomechangeContactsSheetRouteWithChildren
  '/(home)/home/(change-password)/_sheet': typeof homeHomechangePasswordSheetRouteWithChildren
  '/(tv)/tv/$id/(device-management)/_sheet': typeof tvTvIddeviceManagementSheetRouteWithChildren
  '/(tv)/tv/$id/(pins)/_sheet': typeof tvTvIdpinsSheetRouteWithChildren
  '/(tv)/tv/$id/(tv-profiles)/_sheet': typeof tvTvIdtvProfilesSheetRouteWithChildren
  '/(security)/security/_sheet/account-activity/': typeof securitySecuritySheetAccountActivityIndexRoute
  '/(security)/security/_sheet/active-sessions/': typeof securitySecuritySheetActiveSessionsIndexRoute
  '/(security)/security/_sheet/two-factor-code/': typeof securitySecuritySheetTwoFactorCodeIndexRoute
  '/(services)/services/_sheet/apps/': typeof servicesServicesSheetAppsIndexRoute
  '/(services)/services/_sheet/default-household/': typeof servicesServicesSheetDefaultHouseholdIndexRoute
  '/(services)/services/_sheet/switch-services/': typeof servicesServicesSheetSwitchServicesIndexRoute
  '/(services)/services/_sheet/users/': typeof servicesServicesSheetUsersIndexRoute
  '/(security)/security/_mfa-setup/authenticator-app/complete/': typeof securitySecurityMfaSetupAuthenticatorAppCompleteIndexRoute
  '/(security)/security/_mfa-setup/authenticator-app/download-app/': typeof securitySecurityMfaSetupAuthenticatorAppDownloadAppIndexRoute
  '/(security)/security/_mfa-setup/authenticator-app/register/': typeof securitySecurityMfaSetupAuthenticatorAppRegisterIndexRoute
  '/(security)/security/_mfa-setup/authenticator-app/validate/': typeof securitySecurityMfaSetupAuthenticatorAppValidateIndexRoute
  '/(security)/security/_sheet/account-activity/filters/': typeof securitySecuritySheetAccountActivityFiltersIndexRoute
  '/(services)/services/_sheet/switch-services/code-input/': typeof servicesServicesSheetSwitchServicesCodeInputIndexRoute
  '/(services)/services/_sheet/switch-services/contact-selection/': typeof servicesServicesSheetSwitchServicesContactSelectionIndexRoute
  '/(services)/services/_sheet/switch-services/holder-input/': typeof servicesServicesSheetSwitchServicesHolderInputIndexRoute
  '/(services)/services/_sheet/switch-services/success/': typeof servicesServicesSheetSwitchServicesSuccessIndexRoute
  '/(services)/services/_sheet/users/$userId/': typeof servicesServicesSheetUsersUserIdIndexRoute
  '/(services)/services/_sheet/users/add/': typeof servicesServicesSheetUsersAddIndexRoute
  '/(services)/services/_sheet/users/invite-success/': typeof servicesServicesSheetUsersInviteSuccessIndexRoute
  '/(home)/home/(change-contacts)/_sheet/change-contacts/(landing-page)/': typeof homeHomechangeContactsSheetChangeContactslandingPageIndexRoute
  '/(home)/home/(change-contacts)/_sheet/change-contacts/code-input/': typeof homeHomechangeContactsSheetChangeContactsCodeInputIndexRoute
  '/(home)/home/(change-contacts)/_sheet/change-contacts/new-contact/': typeof homeHomechangeContactsSheetChangeContactsNewContactIndexRoute
  '/(home)/home/(change-contacts)/_sheet/change-contacts/username/': typeof homeHomechangeContactsSheetChangeContactsUsernameIndexRoute
  '/(home)/home/(change-password)/_sheet/change-password/(landing-page)/': typeof homeHomechangePasswordSheetChangePasswordlandingPageIndexRoute
  '/(home)/home/(change-password)/_sheet/change-password/code-input/': typeof homeHomechangePasswordSheetChangePasswordCodeInputIndexRoute
  '/(home)/home/(change-password)/_sheet/change-password/contact-selection/': typeof homeHomechangePasswordSheetChangePasswordContactSelectionIndexRoute
  '/(home)/home/(change-password)/_sheet/change-password/new-password/': typeof homeHomechangePasswordSheetChangePasswordNewPasswordIndexRoute
  '/(tv)/tv/$id/(device-management)/_sheet/device-management/': typeof tvTvIddeviceManagementSheetDeviceManagementIndexRoute
  '/(tv)/tv/$id/(pins)/_sheet/pins/$pin/': typeof tvTvIdpinsSheetPinsPinIndexRoute
  '/(tv)/tv/$id/(pins)/_sheet/pins/(pins)/': typeof tvTvIdpinsSheetPinspinsIndexRoute
  '/(tv)/tv/$id/(tv-profiles)/_sheet/profiles/(list)/': typeof tvTvIdtvProfilesSheetProfileslistIndexRoute
  '/(tv)/tv/$id/(tv-profiles)/_sheet/profiles/create/': typeof tvTvIdtvProfilesSheetProfilesCreateIndexRoute
  '/(tv)/tv/$id/(tv-profiles)/_sheet/profiles/select-avatar/': typeof tvTvIdtvProfilesSheetProfilesSelectAvatarIndexRoute
  '/(tv)/tv/$id/(pins)/_sheet/pins/$pin/code-input/': typeof tvTvIdpinsSheetPinsPinCodeInputIndexRoute
  '/(tv)/tv/$id/(pins)/_sheet/pins/$pin/contact-selection/': typeof tvTvIdpinsSheetPinsPinContactSelectionIndexRoute
  '/(tv)/tv/$id/(tv-profiles)/_sheet/profiles/$profileId/update/': typeof tvTvIdtvProfilesSheetProfilesProfileIdUpdateIndexRoute
  '/(tv)/tv/$id/(tv-profiles)/_sheet/profiles/$profileId/update/code-input/': typeof tvTvIdtvProfilesSheetProfilesProfileIdUpdateCodeInputIndexRoute
  '/(tv)/tv/$id/(tv-profiles)/_sheet/profiles/$profileId/update/contact-selection/': typeof tvTvIdtvProfilesSheetProfilesProfileIdUpdateContactSelectionIndexRoute
  '/(tv)/tv/$id/(tv-profiles)/_sheet/profiles/$profileId/update/pin-validation/': typeof tvTvIdtvProfilesSheetProfilesProfileIdUpdatePinValidationIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/devices'
    | '/login-complete'
    | '/silent-token-renew'
    | '/home'
    | '/security'
    | '/services'
    | '/tv/$id'
    | '/tv/'
    | '/security/account-activity/'
    | '/security/active-sessions/'
    | '/security/two-factor-code/'
    | '/services/apps/'
    | '/services/default-household/'
    | '/services/switch-services/'
    | '/services/users/'
    | '/security/authenticator-app/complete/'
    | '/security/authenticator-app/download-app/'
    | '/security/authenticator-app/register/'
    | '/security/authenticator-app/validate/'
    | '/security/account-activity/filters/'
    | '/services/switch-services/code-input/'
    | '/services/switch-services/contact-selection/'
    | '/services/switch-services/holder-input/'
    | '/services/switch-services/success/'
    | '/services/users/$userId/'
    | '/services/users/add/'
    | '/services/users/invite-success/'
    | '/home/change-contacts/'
    | '/home/change-contacts/code-input/'
    | '/home/change-contacts/new-contact/'
    | '/home/change-contacts/username/'
    | '/home/change-password/'
    | '/home/change-password/code-input/'
    | '/home/change-password/contact-selection/'
    | '/home/change-password/new-password/'
    | '/tv/$id/device-management/'
    | '/tv/$id/pins/$pin/'
    | '/tv/$id/pins/'
    | '/tv/$id/profiles/'
    | '/tv/$id/profiles/create/'
    | '/tv/$id/profiles/select-avatar/'
    | '/tv/$id/pins/$pin/code-input/'
    | '/tv/$id/pins/$pin/contact-selection/'
    | '/tv/$id/profiles/$profileId/update/'
    | '/tv/$id/profiles/$profileId/update/code-input/'
    | '/tv/$id/profiles/$profileId/update/contact-selection/'
    | '/tv/$id/profiles/$profileId/update/pin-validation/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/devices'
    | '/login-complete'
    | '/silent-token-renew'
    | '/home'
    | '/security'
    | '/services'
    | '/tv/$id'
    | '/tv'
    | '/security/account-activity'
    | '/security/active-sessions'
    | '/security/two-factor-code'
    | '/services/apps'
    | '/services/default-household'
    | '/services/switch-services'
    | '/services/users'
    | '/security/authenticator-app/complete'
    | '/security/authenticator-app/download-app'
    | '/security/authenticator-app/register'
    | '/security/authenticator-app/validate'
    | '/security/account-activity/filters'
    | '/services/switch-services/code-input'
    | '/services/switch-services/contact-selection'
    | '/services/switch-services/holder-input'
    | '/services/switch-services/success'
    | '/services/users/$userId'
    | '/services/users/add'
    | '/services/users/invite-success'
    | '/home/change-contacts'
    | '/home/change-contacts/code-input'
    | '/home/change-contacts/new-contact'
    | '/home/change-contacts/username'
    | '/home/change-password'
    | '/home/change-password/code-input'
    | '/home/change-password/contact-selection'
    | '/home/change-password/new-password'
    | '/tv/$id/device-management'
    | '/tv/$id/pins/$pin'
    | '/tv/$id/pins'
    | '/tv/$id/profiles'
    | '/tv/$id/profiles/create'
    | '/tv/$id/profiles/select-avatar'
    | '/tv/$id/pins/$pin/code-input'
    | '/tv/$id/pins/$pin/contact-selection'
    | '/tv/$id/profiles/$profileId/update'
    | '/tv/$id/profiles/$profileId/update/code-input'
    | '/tv/$id/profiles/$profileId/update/contact-selection'
    | '/tv/$id/profiles/$profileId/update/pin-validation'
  id:
    | '__root__'
    | '/devices'
    | '/login-complete'
    | '/silent-token-renew'
    | '/(home)/home'
    | '/(security)/security'
    | '/(services)/services'
    | '/(security)/security/_mfa-setup'
    | '/(security)/security/_sheet'
    | '/(services)/services/_sheet'
    | '/(tv)/tv/$id'
    | '/(tv)/tv/'
    | '/(home)/home/(change-contacts)/_sheet'
    | '/(home)/home/(change-password)/_sheet'
    | '/(tv)/tv/$id/(device-management)/_sheet'
    | '/(tv)/tv/$id/(pins)/_sheet'
    | '/(tv)/tv/$id/(tv-profiles)/_sheet'
    | '/(security)/security/_sheet/account-activity/'
    | '/(security)/security/_sheet/active-sessions/'
    | '/(security)/security/_sheet/two-factor-code/'
    | '/(services)/services/_sheet/apps/'
    | '/(services)/services/_sheet/default-household/'
    | '/(services)/services/_sheet/switch-services/'
    | '/(services)/services/_sheet/users/'
    | '/(security)/security/_mfa-setup/authenticator-app/complete/'
    | '/(security)/security/_mfa-setup/authenticator-app/download-app/'
    | '/(security)/security/_mfa-setup/authenticator-app/register/'
    | '/(security)/security/_mfa-setup/authenticator-app/validate/'
    | '/(security)/security/_sheet/account-activity/filters/'
    | '/(services)/services/_sheet/switch-services/code-input/'
    | '/(services)/services/_sheet/switch-services/contact-selection/'
    | '/(services)/services/_sheet/switch-services/holder-input/'
    | '/(services)/services/_sheet/switch-services/success/'
    | '/(services)/services/_sheet/users/$userId/'
    | '/(services)/services/_sheet/users/add/'
    | '/(services)/services/_sheet/users/invite-success/'
    | '/(home)/home/(change-contacts)/_sheet/change-contacts/(landing-page)/'
    | '/(home)/home/(change-contacts)/_sheet/change-contacts/code-input/'
    | '/(home)/home/(change-contacts)/_sheet/change-contacts/new-contact/'
    | '/(home)/home/(change-contacts)/_sheet/change-contacts/username/'
    | '/(home)/home/(change-password)/_sheet/change-password/(landing-page)/'
    | '/(home)/home/(change-password)/_sheet/change-password/code-input/'
    | '/(home)/home/(change-password)/_sheet/change-password/contact-selection/'
    | '/(home)/home/(change-password)/_sheet/change-password/new-password/'
    | '/(tv)/tv/$id/(device-management)/_sheet/device-management/'
    | '/(tv)/tv/$id/(pins)/_sheet/pins/$pin/'
    | '/(tv)/tv/$id/(pins)/_sheet/pins/(pins)/'
    | '/(tv)/tv/$id/(tv-profiles)/_sheet/profiles/(list)/'
    | '/(tv)/tv/$id/(tv-profiles)/_sheet/profiles/create/'
    | '/(tv)/tv/$id/(tv-profiles)/_sheet/profiles/select-avatar/'
    | '/(tv)/tv/$id/(pins)/_sheet/pins/$pin/code-input/'
    | '/(tv)/tv/$id/(pins)/_sheet/pins/$pin/contact-selection/'
    | '/(tv)/tv/$id/(tv-profiles)/_sheet/profiles/$profileId/update/'
    | '/(tv)/tv/$id/(tv-profiles)/_sheet/profiles/$profileId/update/code-input/'
    | '/(tv)/tv/$id/(tv-profiles)/_sheet/profiles/$profileId/update/contact-selection/'
    | '/(tv)/tv/$id/(tv-profiles)/_sheet/profiles/$profileId/update/pin-validation/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  DevicesRoute: typeof DevicesRoute
  LoginCompleteRoute: typeof LoginCompleteRoute
  SilentTokenRenewRoute: typeof SilentTokenRenewRoute
  homeHomeRoute: typeof homeHomeRouteWithChildren
  securitySecurityRoute: typeof securitySecurityRouteWithChildren
  servicesServicesRoute: typeof servicesServicesRouteWithChildren
  tvTvIdRoute: typeof tvTvIdRouteWithChildren
  tvTvIndexRoute: typeof tvTvIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/silent-token-renew': {
      id: '/silent-token-renew'
      path: '/silent-token-renew'
      fullPath: '/silent-token-renew'
      preLoaderRoute: typeof SilentTokenRenewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login-complete': {
      id: '/login-complete'
      path: '/login-complete'
      fullPath: '/login-complete'
      preLoaderRoute: typeof LoginCompleteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/devices': {
      id: '/devices'
      path: '/devices'
      fullPath: '/devices'
      preLoaderRoute: typeof DevicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(services)/services': {
      id: '/(services)/services'
      path: '/services'
      fullPath: '/services'
      preLoaderRoute: typeof servicesServicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(security)/security': {
      id: '/(security)/security'
      path: '/security'
      fullPath: '/security'
      preLoaderRoute: typeof securitySecurityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(home)/home': {
      id: '/(home)/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof homeHomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(tv)/tv/': {
      id: '/(tv)/tv/'
      path: '/tv'
      fullPath: '/tv/'
      preLoaderRoute: typeof tvTvIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(tv)/tv/$id': {
      id: '/(tv)/tv/$id'
      path: '/tv/$id'
      fullPath: '/tv/$id'
      preLoaderRoute: typeof tvTvIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(services)/services/_sheet': {
      id: '/(services)/services/_sheet'
      path: ''
      fullPath: '/services'
      preLoaderRoute: typeof servicesServicesSheetRouteImport
      parentRoute: typeof servicesServicesRoute
    }
    '/(security)/security/_sheet': {
      id: '/(security)/security/_sheet'
      path: ''
      fullPath: '/security'
      preLoaderRoute: typeof securitySecuritySheetRouteImport
      parentRoute: typeof securitySecurityRoute
    }
    '/(security)/security/_mfa-setup': {
      id: '/(security)/security/_mfa-setup'
      path: ''
      fullPath: '/security'
      preLoaderRoute: typeof securitySecurityMfaSetupRouteImport
      parentRoute: typeof securitySecurityRoute
    }
    '/(home)/home/(change-password)/_sheet': {
      id: '/(home)/home/(change-password)/_sheet'
      path: ''
      fullPath: '/home'
      preLoaderRoute: typeof homeHomechangePasswordSheetRouteImport
      parentRoute: typeof homeHomeRoute
    }
    '/(home)/home/(change-contacts)/_sheet': {
      id: '/(home)/home/(change-contacts)/_sheet'
      path: ''
      fullPath: '/home'
      preLoaderRoute: typeof homeHomechangeContactsSheetRouteImport
      parentRoute: typeof homeHomeRoute
    }
    '/(services)/services/_sheet/users/': {
      id: '/(services)/services/_sheet/users/'
      path: '/users'
      fullPath: '/services/users/'
      preLoaderRoute: typeof servicesServicesSheetUsersIndexRouteImport
      parentRoute: typeof servicesServicesSheetRoute
    }
    '/(services)/services/_sheet/switch-services/': {
      id: '/(services)/services/_sheet/switch-services/'
      path: '/switch-services'
      fullPath: '/services/switch-services/'
      preLoaderRoute: typeof servicesServicesSheetSwitchServicesIndexRouteImport
      parentRoute: typeof servicesServicesSheetRoute
    }
    '/(services)/services/_sheet/default-household/': {
      id: '/(services)/services/_sheet/default-household/'
      path: '/default-household'
      fullPath: '/services/default-household/'
      preLoaderRoute: typeof servicesServicesSheetDefaultHouseholdIndexRouteImport
      parentRoute: typeof servicesServicesSheetRoute
    }
    '/(services)/services/_sheet/apps/': {
      id: '/(services)/services/_sheet/apps/'
      path: '/apps'
      fullPath: '/services/apps/'
      preLoaderRoute: typeof servicesServicesSheetAppsIndexRouteImport
      parentRoute: typeof servicesServicesSheetRoute
    }
    '/(security)/security/_sheet/two-factor-code/': {
      id: '/(security)/security/_sheet/two-factor-code/'
      path: '/two-factor-code'
      fullPath: '/security/two-factor-code/'
      preLoaderRoute: typeof securitySecuritySheetTwoFactorCodeIndexRouteImport
      parentRoute: typeof securitySecuritySheetRoute
    }
    '/(security)/security/_sheet/active-sessions/': {
      id: '/(security)/security/_sheet/active-sessions/'
      path: '/active-sessions'
      fullPath: '/security/active-sessions/'
      preLoaderRoute: typeof securitySecuritySheetActiveSessionsIndexRouteImport
      parentRoute: typeof securitySecuritySheetRoute
    }
    '/(security)/security/_sheet/account-activity/': {
      id: '/(security)/security/_sheet/account-activity/'
      path: '/account-activity'
      fullPath: '/security/account-activity/'
      preLoaderRoute: typeof securitySecuritySheetAccountActivityIndexRouteImport
      parentRoute: typeof securitySecuritySheetRoute
    }
    '/(tv)/tv/$id/(tv-profiles)/_sheet': {
      id: '/(tv)/tv/$id/(tv-profiles)/_sheet'
      path: ''
      fullPath: '/tv/$id'
      preLoaderRoute: typeof tvTvIdtvProfilesSheetRouteImport
      parentRoute: typeof tvTvIdRoute
    }
    '/(tv)/tv/$id/(pins)/_sheet': {
      id: '/(tv)/tv/$id/(pins)/_sheet'
      path: ''
      fullPath: '/tv/$id'
      preLoaderRoute: typeof tvTvIdpinsSheetRouteImport
      parentRoute: typeof tvTvIdRoute
    }
    '/(tv)/tv/$id/(device-management)/_sheet': {
      id: '/(tv)/tv/$id/(device-management)/_sheet'
      path: ''
      fullPath: '/tv/$id'
      preLoaderRoute: typeof tvTvIddeviceManagementSheetRouteImport
      parentRoute: typeof tvTvIdRoute
    }
    '/(services)/services/_sheet/users/invite-success/': {
      id: '/(services)/services/_sheet/users/invite-success/'
      path: '/users/invite-success'
      fullPath: '/services/users/invite-success/'
      preLoaderRoute: typeof servicesServicesSheetUsersInviteSuccessIndexRouteImport
      parentRoute: typeof servicesServicesSheetRoute
    }
    '/(services)/services/_sheet/users/add/': {
      id: '/(services)/services/_sheet/users/add/'
      path: '/users/add'
      fullPath: '/services/users/add/'
      preLoaderRoute: typeof servicesServicesSheetUsersAddIndexRouteImport
      parentRoute: typeof servicesServicesSheetRoute
    }
    '/(services)/services/_sheet/users/$userId/': {
      id: '/(services)/services/_sheet/users/$userId/'
      path: '/users/$userId'
      fullPath: '/services/users/$userId/'
      preLoaderRoute: typeof servicesServicesSheetUsersUserIdIndexRouteImport
      parentRoute: typeof servicesServicesSheetRoute
    }
    '/(services)/services/_sheet/switch-services/success/': {
      id: '/(services)/services/_sheet/switch-services/success/'
      path: '/switch-services/success'
      fullPath: '/services/switch-services/success/'
      preLoaderRoute: typeof servicesServicesSheetSwitchServicesSuccessIndexRouteImport
      parentRoute: typeof servicesServicesSheetRoute
    }
    '/(services)/services/_sheet/switch-services/holder-input/': {
      id: '/(services)/services/_sheet/switch-services/holder-input/'
      path: '/switch-services/holder-input'
      fullPath: '/services/switch-services/holder-input/'
      preLoaderRoute: typeof servicesServicesSheetSwitchServicesHolderInputIndexRouteImport
      parentRoute: typeof servicesServicesSheetRoute
    }
    '/(services)/services/_sheet/switch-services/contact-selection/': {
      id: '/(services)/services/_sheet/switch-services/contact-selection/'
      path: '/switch-services/contact-selection'
      fullPath: '/services/switch-services/contact-selection/'
      preLoaderRoute: typeof servicesServicesSheetSwitchServicesContactSelectionIndexRouteImport
      parentRoute: typeof servicesServicesSheetRoute
    }
    '/(services)/services/_sheet/switch-services/code-input/': {
      id: '/(services)/services/_sheet/switch-services/code-input/'
      path: '/switch-services/code-input'
      fullPath: '/services/switch-services/code-input/'
      preLoaderRoute: typeof servicesServicesSheetSwitchServicesCodeInputIndexRouteImport
      parentRoute: typeof servicesServicesSheetRoute
    }
    '/(security)/security/_sheet/account-activity/filters/': {
      id: '/(security)/security/_sheet/account-activity/filters/'
      path: '/account-activity/filters'
      fullPath: '/security/account-activity/filters/'
      preLoaderRoute: typeof securitySecuritySheetAccountActivityFiltersIndexRouteImport
      parentRoute: typeof securitySecuritySheetRoute
    }
    '/(security)/security/_mfa-setup/authenticator-app/validate/': {
      id: '/(security)/security/_mfa-setup/authenticator-app/validate/'
      path: '/authenticator-app/validate'
      fullPath: '/security/authenticator-app/validate/'
      preLoaderRoute: typeof securitySecurityMfaSetupAuthenticatorAppValidateIndexRouteImport
      parentRoute: typeof securitySecurityMfaSetupRoute
    }
    '/(security)/security/_mfa-setup/authenticator-app/register/': {
      id: '/(security)/security/_mfa-setup/authenticator-app/register/'
      path: '/authenticator-app/register'
      fullPath: '/security/authenticator-app/register/'
      preLoaderRoute: typeof securitySecurityMfaSetupAuthenticatorAppRegisterIndexRouteImport
      parentRoute: typeof securitySecurityMfaSetupRoute
    }
    '/(security)/security/_mfa-setup/authenticator-app/download-app/': {
      id: '/(security)/security/_mfa-setup/authenticator-app/download-app/'
      path: '/authenticator-app/download-app'
      fullPath: '/security/authenticator-app/download-app/'
      preLoaderRoute: typeof securitySecurityMfaSetupAuthenticatorAppDownloadAppIndexRouteImport
      parentRoute: typeof securitySecurityMfaSetupRoute
    }
    '/(security)/security/_mfa-setup/authenticator-app/complete/': {
      id: '/(security)/security/_mfa-setup/authenticator-app/complete/'
      path: '/authenticator-app/complete'
      fullPath: '/security/authenticator-app/complete/'
      preLoaderRoute: typeof securitySecurityMfaSetupAuthenticatorAppCompleteIndexRouteImport
      parentRoute: typeof securitySecurityMfaSetupRoute
    }
    '/(tv)/tv/$id/(device-management)/_sheet/device-management/': {
      id: '/(tv)/tv/$id/(device-management)/_sheet/device-management/'
      path: '/device-management'
      fullPath: '/tv/$id/device-management/'
      preLoaderRoute: typeof tvTvIddeviceManagementSheetDeviceManagementIndexRouteImport
      parentRoute: typeof tvTvIddeviceManagementSheetRoute
    }
    '/(home)/home/(change-password)/_sheet/change-password/new-password/': {
      id: '/(home)/home/(change-password)/_sheet/change-password/new-password/'
      path: '/change-password/new-password'
      fullPath: '/home/change-password/new-password/'
      preLoaderRoute: typeof homeHomechangePasswordSheetChangePasswordNewPasswordIndexRouteImport
      parentRoute: typeof homeHomechangePasswordSheetRoute
    }
    '/(home)/home/(change-password)/_sheet/change-password/contact-selection/': {
      id: '/(home)/home/(change-password)/_sheet/change-password/contact-selection/'
      path: '/change-password/contact-selection'
      fullPath: '/home/change-password/contact-selection/'
      preLoaderRoute: typeof homeHomechangePasswordSheetChangePasswordContactSelectionIndexRouteImport
      parentRoute: typeof homeHomechangePasswordSheetRoute
    }
    '/(home)/home/(change-password)/_sheet/change-password/code-input/': {
      id: '/(home)/home/(change-password)/_sheet/change-password/code-input/'
      path: '/change-password/code-input'
      fullPath: '/home/change-password/code-input/'
      preLoaderRoute: typeof homeHomechangePasswordSheetChangePasswordCodeInputIndexRouteImport
      parentRoute: typeof homeHomechangePasswordSheetRoute
    }
    '/(home)/home/(change-password)/_sheet/change-password/(landing-page)/': {
      id: '/(home)/home/(change-password)/_sheet/change-password/(landing-page)/'
      path: '/change-password'
      fullPath: '/home/change-password/'
      preLoaderRoute: typeof homeHomechangePasswordSheetChangePasswordlandingPageIndexRouteImport
      parentRoute: typeof homeHomechangePasswordSheetRoute
    }
    '/(home)/home/(change-contacts)/_sheet/change-contacts/username/': {
      id: '/(home)/home/(change-contacts)/_sheet/change-contacts/username/'
      path: '/change-contacts/username'
      fullPath: '/home/change-contacts/username/'
      preLoaderRoute: typeof homeHomechangeContactsSheetChangeContactsUsernameIndexRouteImport
      parentRoute: typeof homeHomechangeContactsSheetRoute
    }
    '/(home)/home/(change-contacts)/_sheet/change-contacts/new-contact/': {
      id: '/(home)/home/(change-contacts)/_sheet/change-contacts/new-contact/'
      path: '/change-contacts/new-contact'
      fullPath: '/home/change-contacts/new-contact/'
      preLoaderRoute: typeof homeHomechangeContactsSheetChangeContactsNewContactIndexRouteImport
      parentRoute: typeof homeHomechangeContactsSheetRoute
    }
    '/(home)/home/(change-contacts)/_sheet/change-contacts/code-input/': {
      id: '/(home)/home/(change-contacts)/_sheet/change-contacts/code-input/'
      path: '/change-contacts/code-input'
      fullPath: '/home/change-contacts/code-input/'
      preLoaderRoute: typeof homeHomechangeContactsSheetChangeContactsCodeInputIndexRouteImport
      parentRoute: typeof homeHomechangeContactsSheetRoute
    }
    '/(home)/home/(change-contacts)/_sheet/change-contacts/(landing-page)/': {
      id: '/(home)/home/(change-contacts)/_sheet/change-contacts/(landing-page)/'
      path: '/change-contacts'
      fullPath: '/home/change-contacts/'
      preLoaderRoute: typeof homeHomechangeContactsSheetChangeContactslandingPageIndexRouteImport
      parentRoute: typeof homeHomechangeContactsSheetRoute
    }
    '/(tv)/tv/$id/(tv-profiles)/_sheet/profiles/select-avatar/': {
      id: '/(tv)/tv/$id/(tv-profiles)/_sheet/profiles/select-avatar/'
      path: '/profiles/select-avatar'
      fullPath: '/tv/$id/profiles/select-avatar/'
      preLoaderRoute: typeof tvTvIdtvProfilesSheetProfilesSelectAvatarIndexRouteImport
      parentRoute: typeof tvTvIdtvProfilesSheetRoute
    }
    '/(tv)/tv/$id/(tv-profiles)/_sheet/profiles/create/': {
      id: '/(tv)/tv/$id/(tv-profiles)/_sheet/profiles/create/'
      path: '/profiles/create'
      fullPath: '/tv/$id/profiles/create/'
      preLoaderRoute: typeof tvTvIdtvProfilesSheetProfilesCreateIndexRouteImport
      parentRoute: typeof tvTvIdtvProfilesSheetRoute
    }
    '/(tv)/tv/$id/(tv-profiles)/_sheet/profiles/(list)/': {
      id: '/(tv)/tv/$id/(tv-profiles)/_sheet/profiles/(list)/'
      path: '/profiles'
      fullPath: '/tv/$id/profiles/'
      preLoaderRoute: typeof tvTvIdtvProfilesSheetProfileslistIndexRouteImport
      parentRoute: typeof tvTvIdtvProfilesSheetRoute
    }
    '/(tv)/tv/$id/(pins)/_sheet/pins/(pins)/': {
      id: '/(tv)/tv/$id/(pins)/_sheet/pins/(pins)/'
      path: '/pins'
      fullPath: '/tv/$id/pins/'
      preLoaderRoute: typeof tvTvIdpinsSheetPinspinsIndexRouteImport
      parentRoute: typeof tvTvIdpinsSheetRoute
    }
    '/(tv)/tv/$id/(pins)/_sheet/pins/$pin/': {
      id: '/(tv)/tv/$id/(pins)/_sheet/pins/$pin/'
      path: '/pins/$pin'
      fullPath: '/tv/$id/pins/$pin/'
      preLoaderRoute: typeof tvTvIdpinsSheetPinsPinIndexRouteImport
      parentRoute: typeof tvTvIdpinsSheetRoute
    }
    '/(tv)/tv/$id/(tv-profiles)/_sheet/profiles/$profileId/update/': {
      id: '/(tv)/tv/$id/(tv-profiles)/_sheet/profiles/$profileId/update/'
      path: '/profiles/$profileId/update'
      fullPath: '/tv/$id/profiles/$profileId/update/'
      preLoaderRoute: typeof tvTvIdtvProfilesSheetProfilesProfileIdUpdateIndexRouteImport
      parentRoute: typeof tvTvIdtvProfilesSheetRoute
    }
    '/(tv)/tv/$id/(pins)/_sheet/pins/$pin/contact-selection/': {
      id: '/(tv)/tv/$id/(pins)/_sheet/pins/$pin/contact-selection/'
      path: '/pins/$pin/contact-selection'
      fullPath: '/tv/$id/pins/$pin/contact-selection/'
      preLoaderRoute: typeof tvTvIdpinsSheetPinsPinContactSelectionIndexRouteImport
      parentRoute: typeof tvTvIdpinsSheetRoute
    }
    '/(tv)/tv/$id/(pins)/_sheet/pins/$pin/code-input/': {
      id: '/(tv)/tv/$id/(pins)/_sheet/pins/$pin/code-input/'
      path: '/pins/$pin/code-input'
      fullPath: '/tv/$id/pins/$pin/code-input/'
      preLoaderRoute: typeof tvTvIdpinsSheetPinsPinCodeInputIndexRouteImport
      parentRoute: typeof tvTvIdpinsSheetRoute
    }
    '/(tv)/tv/$id/(tv-profiles)/_sheet/profiles/$profileId/update/pin-validation/': {
      id: '/(tv)/tv/$id/(tv-profiles)/_sheet/profiles/$profileId/update/pin-validation/'
      path: '/profiles/$profileId/update/pin-validation'
      fullPath: '/tv/$id/profiles/$profileId/update/pin-validation/'
      preLoaderRoute: typeof tvTvIdtvProfilesSheetProfilesProfileIdUpdatePinValidationIndexRouteImport
      parentRoute: typeof tvTvIdtvProfilesSheetRoute
    }
    '/(tv)/tv/$id/(tv-profiles)/_sheet/profiles/$profileId/update/contact-selection/': {
      id: '/(tv)/tv/$id/(tv-profiles)/_sheet/profiles/$profileId/update/contact-selection/'
      path: '/profiles/$profileId/update/contact-selection'
      fullPath: '/tv/$id/profiles/$profileId/update/contact-selection/'
      preLoaderRoute: typeof tvTvIdtvProfilesSheetProfilesProfileIdUpdateContactSelectionIndexRouteImport
      parentRoute: typeof tvTvIdtvProfilesSheetRoute
    }
    '/(tv)/tv/$id/(tv-profiles)/_sheet/profiles/$profileId/update/code-input/': {
      id: '/(tv)/tv/$id/(tv-profiles)/_sheet/profiles/$profileId/update/code-input/'
      path: '/profiles/$profileId/update/code-input'
      fullPath: '/tv/$id/profiles/$profileId/update/code-input/'
      preLoaderRoute: typeof tvTvIdtvProfilesSheetProfilesProfileIdUpdateCodeInputIndexRouteImport
      parentRoute: typeof tvTvIdtvProfilesSheetRoute
    }
  }
}

interface homeHomechangeContactsSheetRouteChildren {
  homeHomechangeContactsSheetChangeContactslandingPageIndexRoute: typeof homeHomechangeContactsSheetChangeContactslandingPageIndexRoute
  homeHomechangeContactsSheetChangeContactsCodeInputIndexRoute: typeof homeHomechangeContactsSheetChangeContactsCodeInputIndexRoute
  homeHomechangeContactsSheetChangeContactsNewContactIndexRoute: typeof homeHomechangeContactsSheetChangeContactsNewContactIndexRoute
  homeHomechangeContactsSheetChangeContactsUsernameIndexRoute: typeof homeHomechangeContactsSheetChangeContactsUsernameIndexRoute
}

const homeHomechangeContactsSheetRouteChildren: homeHomechangeContactsSheetRouteChildren =
  {
    homeHomechangeContactsSheetChangeContactslandingPageIndexRoute:
      homeHomechangeContactsSheetChangeContactslandingPageIndexRoute,
    homeHomechangeContactsSheetChangeContactsCodeInputIndexRoute:
      homeHomechangeContactsSheetChangeContactsCodeInputIndexRoute,
    homeHomechangeContactsSheetChangeContactsNewContactIndexRoute:
      homeHomechangeContactsSheetChangeContactsNewContactIndexRoute,
    homeHomechangeContactsSheetChangeContactsUsernameIndexRoute:
      homeHomechangeContactsSheetChangeContactsUsernameIndexRoute,
  }

const homeHomechangeContactsSheetRouteWithChildren =
  homeHomechangeContactsSheetRoute._addFileChildren(
    homeHomechangeContactsSheetRouteChildren,
  )

interface homeHomechangePasswordSheetRouteChildren {
  homeHomechangePasswordSheetChangePasswordlandingPageIndexRoute: typeof homeHomechangePasswordSheetChangePasswordlandingPageIndexRoute
  homeHomechangePasswordSheetChangePasswordCodeInputIndexRoute: typeof homeHomechangePasswordSheetChangePasswordCodeInputIndexRoute
  homeHomechangePasswordSheetChangePasswordContactSelectionIndexRoute: typeof homeHomechangePasswordSheetChangePasswordContactSelectionIndexRoute
  homeHomechangePasswordSheetChangePasswordNewPasswordIndexRoute: typeof homeHomechangePasswordSheetChangePasswordNewPasswordIndexRoute
}

const homeHomechangePasswordSheetRouteChildren: homeHomechangePasswordSheetRouteChildren =
  {
    homeHomechangePasswordSheetChangePasswordlandingPageIndexRoute:
      homeHomechangePasswordSheetChangePasswordlandingPageIndexRoute,
    homeHomechangePasswordSheetChangePasswordCodeInputIndexRoute:
      homeHomechangePasswordSheetChangePasswordCodeInputIndexRoute,
    homeHomechangePasswordSheetChangePasswordContactSelectionIndexRoute:
      homeHomechangePasswordSheetChangePasswordContactSelectionIndexRoute,
    homeHomechangePasswordSheetChangePasswordNewPasswordIndexRoute:
      homeHomechangePasswordSheetChangePasswordNewPasswordIndexRoute,
  }

const homeHomechangePasswordSheetRouteWithChildren =
  homeHomechangePasswordSheetRoute._addFileChildren(
    homeHomechangePasswordSheetRouteChildren,
  )

interface homeHomeRouteChildren {
  homeHomechangeContactsSheetRoute: typeof homeHomechangeContactsSheetRouteWithChildren
  homeHomechangePasswordSheetRoute: typeof homeHomechangePasswordSheetRouteWithChildren
}

const homeHomeRouteChildren: homeHomeRouteChildren = {
  homeHomechangeContactsSheetRoute:
    homeHomechangeContactsSheetRouteWithChildren,
  homeHomechangePasswordSheetRoute:
    homeHomechangePasswordSheetRouteWithChildren,
}

const homeHomeRouteWithChildren = homeHomeRoute._addFileChildren(
  homeHomeRouteChildren,
)

interface securitySecurityMfaSetupRouteChildren {
  securitySecurityMfaSetupAuthenticatorAppCompleteIndexRoute: typeof securitySecurityMfaSetupAuthenticatorAppCompleteIndexRoute
  securitySecurityMfaSetupAuthenticatorAppDownloadAppIndexRoute: typeof securitySecurityMfaSetupAuthenticatorAppDownloadAppIndexRoute
  securitySecurityMfaSetupAuthenticatorAppRegisterIndexRoute: typeof securitySecurityMfaSetupAuthenticatorAppRegisterIndexRoute
  securitySecurityMfaSetupAuthenticatorAppValidateIndexRoute: typeof securitySecurityMfaSetupAuthenticatorAppValidateIndexRoute
}

const securitySecurityMfaSetupRouteChildren: securitySecurityMfaSetupRouteChildren =
  {
    securitySecurityMfaSetupAuthenticatorAppCompleteIndexRoute:
      securitySecurityMfaSetupAuthenticatorAppCompleteIndexRoute,
    securitySecurityMfaSetupAuthenticatorAppDownloadAppIndexRoute:
      securitySecurityMfaSetupAuthenticatorAppDownloadAppIndexRoute,
    securitySecurityMfaSetupAuthenticatorAppRegisterIndexRoute:
      securitySecurityMfaSetupAuthenticatorAppRegisterIndexRoute,
    securitySecurityMfaSetupAuthenticatorAppValidateIndexRoute:
      securitySecurityMfaSetupAuthenticatorAppValidateIndexRoute,
  }

const securitySecurityMfaSetupRouteWithChildren =
  securitySecurityMfaSetupRoute._addFileChildren(
    securitySecurityMfaSetupRouteChildren,
  )

interface securitySecuritySheetRouteChildren {
  securitySecuritySheetAccountActivityIndexRoute: typeof securitySecuritySheetAccountActivityIndexRoute
  securitySecuritySheetActiveSessionsIndexRoute: typeof securitySecuritySheetActiveSessionsIndexRoute
  securitySecuritySheetTwoFactorCodeIndexRoute: typeof securitySecuritySheetTwoFactorCodeIndexRoute
  securitySecuritySheetAccountActivityFiltersIndexRoute: typeof securitySecuritySheetAccountActivityFiltersIndexRoute
}

const securitySecuritySheetRouteChildren: securitySecuritySheetRouteChildren = {
  securitySecuritySheetAccountActivityIndexRoute:
    securitySecuritySheetAccountActivityIndexRoute,
  securitySecuritySheetActiveSessionsIndexRoute:
    securitySecuritySheetActiveSessionsIndexRoute,
  securitySecuritySheetTwoFactorCodeIndexRoute:
    securitySecuritySheetTwoFactorCodeIndexRoute,
  securitySecuritySheetAccountActivityFiltersIndexRoute:
    securitySecuritySheetAccountActivityFiltersIndexRoute,
}

const securitySecuritySheetRouteWithChildren =
  securitySecuritySheetRoute._addFileChildren(
    securitySecuritySheetRouteChildren,
  )

interface securitySecurityRouteChildren {
  securitySecurityMfaSetupRoute: typeof securitySecurityMfaSetupRouteWithChildren
  securitySecuritySheetRoute: typeof securitySecuritySheetRouteWithChildren
}

const securitySecurityRouteChildren: securitySecurityRouteChildren = {
  securitySecurityMfaSetupRoute: securitySecurityMfaSetupRouteWithChildren,
  securitySecuritySheetRoute: securitySecuritySheetRouteWithChildren,
}

const securitySecurityRouteWithChildren =
  securitySecurityRoute._addFileChildren(securitySecurityRouteChildren)

interface servicesServicesSheetRouteChildren {
  servicesServicesSheetAppsIndexRoute: typeof servicesServicesSheetAppsIndexRoute
  servicesServicesSheetDefaultHouseholdIndexRoute: typeof servicesServicesSheetDefaultHouseholdIndexRoute
  servicesServicesSheetSwitchServicesIndexRoute: typeof servicesServicesSheetSwitchServicesIndexRoute
  servicesServicesSheetUsersIndexRoute: typeof servicesServicesSheetUsersIndexRoute
  servicesServicesSheetSwitchServicesCodeInputIndexRoute: typeof servicesServicesSheetSwitchServicesCodeInputIndexRoute
  servicesServicesSheetSwitchServicesContactSelectionIndexRoute: typeof servicesServicesSheetSwitchServicesContactSelectionIndexRoute
  servicesServicesSheetSwitchServicesHolderInputIndexRoute: typeof servicesServicesSheetSwitchServicesHolderInputIndexRoute
  servicesServicesSheetSwitchServicesSuccessIndexRoute: typeof servicesServicesSheetSwitchServicesSuccessIndexRoute
  servicesServicesSheetUsersUserIdIndexRoute: typeof servicesServicesSheetUsersUserIdIndexRoute
  servicesServicesSheetUsersAddIndexRoute: typeof servicesServicesSheetUsersAddIndexRoute
  servicesServicesSheetUsersInviteSuccessIndexRoute: typeof servicesServicesSheetUsersInviteSuccessIndexRoute
}

const servicesServicesSheetRouteChildren: servicesServicesSheetRouteChildren = {
  servicesServicesSheetAppsIndexRoute: servicesServicesSheetAppsIndexRoute,
  servicesServicesSheetDefaultHouseholdIndexRoute:
    servicesServicesSheetDefaultHouseholdIndexRoute,
  servicesServicesSheetSwitchServicesIndexRoute:
    servicesServicesSheetSwitchServicesIndexRoute,
  servicesServicesSheetUsersIndexRoute: servicesServicesSheetUsersIndexRoute,
  servicesServicesSheetSwitchServicesCodeInputIndexRoute:
    servicesServicesSheetSwitchServicesCodeInputIndexRoute,
  servicesServicesSheetSwitchServicesContactSelectionIndexRoute:
    servicesServicesSheetSwitchServicesContactSelectionIndexRoute,
  servicesServicesSheetSwitchServicesHolderInputIndexRoute:
    servicesServicesSheetSwitchServicesHolderInputIndexRoute,
  servicesServicesSheetSwitchServicesSuccessIndexRoute:
    servicesServicesSheetSwitchServicesSuccessIndexRoute,
  servicesServicesSheetUsersUserIdIndexRoute:
    servicesServicesSheetUsersUserIdIndexRoute,
  servicesServicesSheetUsersAddIndexRoute:
    servicesServicesSheetUsersAddIndexRoute,
  servicesServicesSheetUsersInviteSuccessIndexRoute:
    servicesServicesSheetUsersInviteSuccessIndexRoute,
}

const servicesServicesSheetRouteWithChildren =
  servicesServicesSheetRoute._addFileChildren(
    servicesServicesSheetRouteChildren,
  )

interface servicesServicesRouteChildren {
  servicesServicesSheetRoute: typeof servicesServicesSheetRouteWithChildren
}

const servicesServicesRouteChildren: servicesServicesRouteChildren = {
  servicesServicesSheetRoute: servicesServicesSheetRouteWithChildren,
}

const servicesServicesRouteWithChildren =
  servicesServicesRoute._addFileChildren(servicesServicesRouteChildren)

interface tvTvIddeviceManagementSheetRouteChildren {
  tvTvIddeviceManagementSheetDeviceManagementIndexRoute: typeof tvTvIddeviceManagementSheetDeviceManagementIndexRoute
}

const tvTvIddeviceManagementSheetRouteChildren: tvTvIddeviceManagementSheetRouteChildren =
  {
    tvTvIddeviceManagementSheetDeviceManagementIndexRoute:
      tvTvIddeviceManagementSheetDeviceManagementIndexRoute,
  }

const tvTvIddeviceManagementSheetRouteWithChildren =
  tvTvIddeviceManagementSheetRoute._addFileChildren(
    tvTvIddeviceManagementSheetRouteChildren,
  )

interface tvTvIdpinsSheetRouteChildren {
  tvTvIdpinsSheetPinsPinIndexRoute: typeof tvTvIdpinsSheetPinsPinIndexRoute
  tvTvIdpinsSheetPinspinsIndexRoute: typeof tvTvIdpinsSheetPinspinsIndexRoute
  tvTvIdpinsSheetPinsPinCodeInputIndexRoute: typeof tvTvIdpinsSheetPinsPinCodeInputIndexRoute
  tvTvIdpinsSheetPinsPinContactSelectionIndexRoute: typeof tvTvIdpinsSheetPinsPinContactSelectionIndexRoute
}

const tvTvIdpinsSheetRouteChildren: tvTvIdpinsSheetRouteChildren = {
  tvTvIdpinsSheetPinsPinIndexRoute: tvTvIdpinsSheetPinsPinIndexRoute,
  tvTvIdpinsSheetPinspinsIndexRoute: tvTvIdpinsSheetPinspinsIndexRoute,
  tvTvIdpinsSheetPinsPinCodeInputIndexRoute:
    tvTvIdpinsSheetPinsPinCodeInputIndexRoute,
  tvTvIdpinsSheetPinsPinContactSelectionIndexRoute:
    tvTvIdpinsSheetPinsPinContactSelectionIndexRoute,
}

const tvTvIdpinsSheetRouteWithChildren = tvTvIdpinsSheetRoute._addFileChildren(
  tvTvIdpinsSheetRouteChildren,
)

interface tvTvIdtvProfilesSheetRouteChildren {
  tvTvIdtvProfilesSheetProfileslistIndexRoute: typeof tvTvIdtvProfilesSheetProfileslistIndexRoute
  tvTvIdtvProfilesSheetProfilesCreateIndexRoute: typeof tvTvIdtvProfilesSheetProfilesCreateIndexRoute
  tvTvIdtvProfilesSheetProfilesSelectAvatarIndexRoute: typeof tvTvIdtvProfilesSheetProfilesSelectAvatarIndexRoute
  tvTvIdtvProfilesSheetProfilesProfileIdUpdateIndexRoute: typeof tvTvIdtvProfilesSheetProfilesProfileIdUpdateIndexRoute
  tvTvIdtvProfilesSheetProfilesProfileIdUpdateCodeInputIndexRoute: typeof tvTvIdtvProfilesSheetProfilesProfileIdUpdateCodeInputIndexRoute
  tvTvIdtvProfilesSheetProfilesProfileIdUpdateContactSelectionIndexRoute: typeof tvTvIdtvProfilesSheetProfilesProfileIdUpdateContactSelectionIndexRoute
  tvTvIdtvProfilesSheetProfilesProfileIdUpdatePinValidationIndexRoute: typeof tvTvIdtvProfilesSheetProfilesProfileIdUpdatePinValidationIndexRoute
}

const tvTvIdtvProfilesSheetRouteChildren: tvTvIdtvProfilesSheetRouteChildren = {
  tvTvIdtvProfilesSheetProfileslistIndexRoute:
    tvTvIdtvProfilesSheetProfileslistIndexRoute,
  tvTvIdtvProfilesSheetProfilesCreateIndexRoute:
    tvTvIdtvProfilesSheetProfilesCreateIndexRoute,
  tvTvIdtvProfilesSheetProfilesSelectAvatarIndexRoute:
    tvTvIdtvProfilesSheetProfilesSelectAvatarIndexRoute,
  tvTvIdtvProfilesSheetProfilesProfileIdUpdateIndexRoute:
    tvTvIdtvProfilesSheetProfilesProfileIdUpdateIndexRoute,
  tvTvIdtvProfilesSheetProfilesProfileIdUpdateCodeInputIndexRoute:
    tvTvIdtvProfilesSheetProfilesProfileIdUpdateCodeInputIndexRoute,
  tvTvIdtvProfilesSheetProfilesProfileIdUpdateContactSelectionIndexRoute:
    tvTvIdtvProfilesSheetProfilesProfileIdUpdateContactSelectionIndexRoute,
  tvTvIdtvProfilesSheetProfilesProfileIdUpdatePinValidationIndexRoute:
    tvTvIdtvProfilesSheetProfilesProfileIdUpdatePinValidationIndexRoute,
}

const tvTvIdtvProfilesSheetRouteWithChildren =
  tvTvIdtvProfilesSheetRoute._addFileChildren(
    tvTvIdtvProfilesSheetRouteChildren,
  )

interface tvTvIdRouteChildren {
  tvTvIddeviceManagementSheetRoute: typeof tvTvIddeviceManagementSheetRouteWithChildren
  tvTvIdpinsSheetRoute: typeof tvTvIdpinsSheetRouteWithChildren
  tvTvIdtvProfilesSheetRoute: typeof tvTvIdtvProfilesSheetRouteWithChildren
}

const tvTvIdRouteChildren: tvTvIdRouteChildren = {
  tvTvIddeviceManagementSheetRoute:
    tvTvIddeviceManagementSheetRouteWithChildren,
  tvTvIdpinsSheetRoute: tvTvIdpinsSheetRouteWithChildren,
  tvTvIdtvProfilesSheetRoute: tvTvIdtvProfilesSheetRouteWithChildren,
}

const tvTvIdRouteWithChildren =
  tvTvIdRoute._addFileChildren(tvTvIdRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  DevicesRoute: DevicesRoute,
  LoginCompleteRoute: LoginCompleteRoute,
  SilentTokenRenewRoute: SilentTokenRenewRoute,
  homeHomeRoute: homeHomeRouteWithChildren,
  securitySecurityRoute: securitySecurityRouteWithChildren,
  servicesServicesRoute: servicesServicesRouteWithChildren,
  tvTvIdRoute: tvTvIdRouteWithChildren,
  tvTvIndexRoute: tvTvIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
